import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Button, Menu, MenuItem, Paper, Typography } from "@mui/material";
import { useState } from "react";



const ProfitLossChart = ({ total_revenue, total_expense, net_profit , onPeriodChange}) => {
    const [period, setPeriod] = useState("Monthly");
    const [anchorEl, setAnchorEl] = useState(null);
    const chartData = [
        { name: "Revenue", value: total_revenue },
        { name: "Expense", value: total_expense },
        { name: "Profit", value: net_profit },
        { name: "Comparison %", value: (net_profit / total_revenue) * 100 }
    ];
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (selectedPeriod) => {
        if (selectedPeriod) {
            setPeriod(selectedPeriod);
            onPeriodChange(selectedPeriod); 
        }
        setAnchorEl(null);
    };

    return (
        <Paper elevation={1} sx={{ p: 1, borderRadius: 1 }}>
            {/* Header Section */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <Typography variant="h6" fontWeight="bold">
                    Profit & Loss Statement
                </Typography>
                <div>
                    <button
                        variant="outlined"
                        onClick={handleClick}
                        className="border border-[#000000] text-[#000000] text-xs h-[30px] px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#A9A9A9]"
                    >
                        {period} <span className="text-xs">▼</span>
                    </button>

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose(null)}>
                        <MenuItem onClick={() => handleClose("Monthly")}>Monthly</MenuItem>
                        <MenuItem onClick={() => handleClose("Yearly")}>Yearly</MenuItem>
                    </Menu>
                </div>
            </div>

            {/* Chart Section */}
            <ResponsiveContainer width="100%" height={220}>
                <BarChart data={chartData} margin={{ top: 10, right: 10, left: 30, bottom: 1 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis tickFormatter={(tick) => `₹ ${tick / 100}k`} />
                    <Tooltip formatter={(value) => `₹ ${value}`} />
                    <Bar dataKey="value" fill="#1010AA" barSize={40} />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
};

export default ProfitLossChart;

